import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import {FirebaseContext} from "../../../context/firebase";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AppBar from "../components/AppBar";


interface Props {
    handleBeneficiaryOpen4: ()=> void
    setTransactionDetailsActiveItem: React.Dispatch<any>
}


const splitArray = (masterArray: any, chunkSize: number) => {
    const result = [];
    for (let i = 0; i < masterArray.length; i += chunkSize) {
        result.push(masterArray.slice(i, i + chunkSize));
    }
    return result;
};


const Transaction: React.FC<Props>=({ handleBeneficiaryOpen4, setTransactionDetailsActiveItem })=>{
      const { data, error, refresh } = useContext(FirebaseContext);


    const [transactions, setTransactions] = useState<any>([])
    useEffect(() => {
      if (data?.transactions) {
        setTransactions([...data.transactions].reverse());
      }
    }, [data]);

    const [splitArrays, setSplitArrays] = useState<any>();
    const [spliteCount, setSpliteCount] = useState<number>(0);

    const [transactionType, setTransactionType] = useState('all')    
    const [applyActive, setApplyActive] = useState(false)
    const [startDate, setStartDate] = useState<any>(new Date());
    const [endDate, setEndDate] = useState<any>(new Date());
    const [filteredArray, setFilteredArray] = useState<any>([])
    const [rangeArrayNothing, setRangeArrayNothing] = useState<boolean>(false)

    ///
        /* 
            Work on the filter. First check how its implement on mynt
            
        */
    ///
    function formatDate1(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero
        const day = String(date.getDate()).padStart(2, '0'); // Add leading zero
      
        return `${year}-${month}-${day}`;
    }

    function filterByDateRange(data: any, startDateString: any, stopDateString: any) {
        // Parse start and stop dates into Date objects
        const startDate = new Date(startDateString);
        const stopDate = new Date(stopDateString);
      
        // Filter items based on date comparison
        return data.filter((item: any) => {
          // Check if the item has a date property
          if (!item.hasOwnProperty('date')) {
            console.warn(`Item missing 'date' property:`, item);
            return false; // Exclude items without a date property
          }
      
          // Parse item date into a Date object
          const itemDateString = item.date;
          const itemDate = new Date(itemDateString);
      
          return itemDate >= startDate && itemDate <= stopDate; // Check if date is within range
        });
    }

    const applyFilter =()=>{

        setApplyActive(true)
        setRangeArrayNothing(false)

        if(startDate && endDate){
            const startDateString = formatDate1(startDate)
            const endDateString = formatDate1(endDate)
            var rangeArray: any[] = []
            
            rangeArray = filterByDateRange(transactions, startDateString, endDateString)
          if(transactionType != 'all'){
                setFilteredArray(rangeArray.filter((item: any) => item.type == transactionType))
            }else{
                setFilteredArray(rangeArray)
            }
            
        }else{
            if(transactionType === 'all' && data.transactions){
                setFilteredArray([...data.transactions].reverse())
            } else if(transactionType === 'credit' && data.transactions){
                setFilteredArray([...data.transactions].filter(item => item.type === 'credit').reverse())
            } else if(transactionType === 'debit' && data.transactions){
                setFilteredArray([...data.transactions].filter(item => item.type === 'debit').reverse())
            }
        }

    }
    const resetFunction = () => {
        setRangeArrayNothing(false)
        setApplyActive(false)
        setFilteredArray([])
        setStartDate(new Date())
        setEndDate(new Date())

        if (data?.transactions) {
            setTransactions([...data.transactions].reverse());
        }
    }


    const splitNext =()=>{
        if(spliteCount + 1 < splitArrays.length){
            setSpliteCount(spliteCount + 1)
        }else{
            setSpliteCount(0)
        }
    }

    const splitPrev =()=>{
        if(spliteCount + 1 > 1){
            setSpliteCount(spliteCount - 1)
        }else{
            setSpliteCount(splitArrays.length - 1)
        }
    }

    useEffect(() => {
      if (applyActive && filteredArray.length > 0) {
        const chunks = splitArray(filteredArray, 10);
        setSplitArrays(chunks);
      } else if (applyActive && filteredArray.length < 1) {
        setRangeArrayNothing(true);
      } else {
        if (transactions.length > 0) {
          const chunks = splitArray(transactions, 10);
          setSplitArrays(chunks);
        }
      }
    }, [applyActive, filteredArray, transactions]);
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1)
    };


    const handleViewDetail=(item: any)=>{
        setTransactionDetailsActiveItem(item)
        handleBeneficiaryOpen4()
    }
    
    return (
        <main id="content">
            <AppBar/>

            <section className="container">

                <div className="transaction-back">
                    <button className="transaction-back-btn" onClick={handleGoBack}>
                        <img src="/imgs/angle.svg" alt="" />
                        <span>Back</span>
                    </button>
                </div>

                <div style={{paddingTop: '3rem'}}>
                    <h1 className="tranfer-title-text">Transactions</h1>
                    <p className="tranfer-lead-text">See all transaction history</p>


                    <div className="custom-tabs" style={{marginTop: '3rem', width: '100%'}}>
                        <ul role="tablist">
                            <li role="tab"><span id="invest-option-1" className="active">Transfers</span></li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div style={{margin: '32px 0'}}>
                        <div className="transaction-form">
                             <div style={{ marginBottom: '1rem', marginRight: '0.6rem' }}>
                                <label style={{display: 'block', color: '#000', fontSize: '12px', fontWeight: '600', marginBottom: '0.3rem'}}>Transaction Type</label>
                                <select className="react-select__control css-ismsy3-control" onClick={(e)=> setTransactionType(e.currentTarget.value)}>
                                    <option value='all'>All types</option>
                                    
                                    <option value="credit">Credit only</option>
                                    <option value="debit">Debit only</option>
                                </select>
                            </div>

                            <div style={{ marginBottom: '1rem', marginRight: '0.6rem' }}>
                                <label style={{display: 'block', color: '#000', fontSize: '12px', fontWeight: '600', marginBottom: '0.3rem'}}>Start Date</label>
                                <DatePicker 
                                    selected={endDate} 
                                    onChange={(date) => setEndDate(date)} 
                                    className="react-select__control css-ismsy3-control"
                                />
                                {/* <input type="date" id="transactionFilterDateFrom" className="react-select__control css-ismsy3-control" style={{textTransform: 'uppercase'}} onClick={(e)=>setTransactionFrom(e.currentTarget.value)}/> */}
                            </div>

                            <div style={{ marginBottom: '1rem', marginRight: '0.6rem' }}>
                                <label style={{display: 'block', color: '#000', fontSize: '12px', fontWeight: '600', marginBottom: '0.3rem'}}>End Date</label>
                                <DatePicker 
                                    selected={startDate} 
                                    onChange={(date) => setStartDate(date)} 
                                    className="react-select__control css-ismsy3-control"
                                />
                                {/* <input type="date" className="react-select__control css-ismsy3-control" style={{textTransform: 'uppercase'}} onClick={(e)=> setTransactionTo(e.currentTarget.value)}/> */}
                            </div>


                            <div style={{ marginBottom: '1rem', marginRight: '0.6rem' }}>
                                <label style={{display: 'block', color: '#000', fontSize: '12px', fontWeight: '600', marginBottom: '0.3rem'}}>&nbsp;</label>
                                <button className="btn transaction-button" style={{textTransform: 'uppercase'}} onClick={()=>applyFilter()}>Apply</button>
                            </div>

                            {
                                applyActive
                                ?
                                <div style={{ marginBottom: '1rem' }} onClick={resetFunction}>
                                    <label style={{display: 'block', color: '#000', fontSize: '12px', fontWeight: '600', marginBottom: '0.3rem'}}>&nbsp;</label>
                                    <button className="btn transaction-button-reset" style={{textTransform: 'uppercase'}}>Reset</button>
                                </div>
                                :
                                null
                            }


                        </div>
                    </div>
                </div>

                <div className="transactions-groom-panel">
                    <div className="transactions-responsive-table">
                        <div className="transaction-table">
                            <table className="table table-bordered th-table" style={{width: '100%', textAlign: 'left'}}>
                                <thead>
                                    <tr>
                                        <th>S/N</th>
                                        <th>Transaction Date</th>
                                        <th>Time</th><th>Transfer amount</th>
                                        <th>Narration</th>
                                        <th>Transaction Ref</th>
                                        <th>Details</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        rangeArrayNothing
                                        ?
                                        <tr style={{textAlign: 'center', display: 'block', width: '100%', fontSize: '1.2rem', fontWeight: '600', color: 'gray'}}><th>No transaction to display</th></tr>
                                        :
                                        splitArrays
                                        ?
                                        splitArrays[spliteCount].map((item: any, index: number) => {
                                            
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td style={{fontWeight: '600'}}>{item.date}</td>
                                                    <td style={{fontWeight: '600'}}>{item.time}</td>
                                                    <td>
                                                        <div className={`${item.type == "credit" ? "is-credit" : "is-debit"}`}>${item.amount}</div>
                                                    </td>
                                                    <td>
                                                        <div className="th-narration" style={{fontWeight: '600'}}>{item.narration}</div>
                                                    </td>
                                                    <td style={{fontWeight: '600'}}>{item.transactionRef}</td>
                                                    <td>
                                                        <button onClick={()=> handleViewDetail(item)} className="th-details-btn">View details</button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="container transaction-customPagination">
                    <ul className="transaction-pagination">
                        <li className="transaction-transaction-page-item">
                            <a className="transaction-page-link notactive" style={{cursor: 'pointer'}} onClick={()=> splitPrev()}>Prev</a>
                        </li>
                        {
                            splitArrays
                            ?
                            splitArrays.map((item: any, index: number) =>{
                                return (
                                    <li className={`${index === spliteCount ? "transaction-page-item active" : "transaction-page-item"}`}>
                                        <a className="transaction-page-link" style={{cursor: 'pointer'}} onClick={()=> setSpliteCount(index)}>{index + 1}</a>
                                    </li>
                                )
                            })
                            :
                            null
                        }
                        <li className="transaction-page-item notactive">
                            <a className="transaction-page-link" style={{cursor: 'pointer'}} onClick={()=> splitNext()}>Next</a>
                        </li>
                    </ul>
                </div>


            </section>

        </main>
    )
}

export default Transaction